import { render, staticRenderFns } from "./_CreateOrEdit.vue?vue&type=template&id=5bbc8cb2&scoped=true&"
import script from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
export * from "./_CreateOrEdit.vue?vue&type=script&lang=js&"
import style0 from "./_CreateOrEdit.vue?vue&type=style&index=0&id=5bbc8cb2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bbc8cb2",
  null
  
)

export default component.exports